import { useState } from 'react';

// Password box with a show/hide eye — the same 👁 / 🙈 toggle Admin Config's
// camera forms use (probe-pass-wrap), as one reusable piece. Every other prop
// goes straight to the <input>, so it drops in wherever type="password" was.
export default function PasswordInput({ className = '', wrapClassName = '', disabled, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className={`pw-wrap ${wrapClassName}`.trim()}>
      <input {...props} disabled={disabled} className={className} type={show ? 'text' : 'password'} />
      <button type="button" className="pw-eye" disabled={disabled} tabIndex={-1}
              onClick={() => setShow(s => !s)}
              aria-label={show ? 'Hide password' : 'Show password'}
              title={show ? 'Hide password' : 'Show password'}>
        {show ? '🙈' : '👁'}
      </button>
    </div>
  );
}
